import React from 'react'

export const Loader = () => (
  <div className="d-flex justify-content-center pt-5 pb-5">
    <div className="mt-5 mb-5 fa fa-spinner fa-spin fa-3x" />
  </div>
)

// This is a Higher Order Component
// Wrapping other components to add a loading spinner for GraphQL queries
// See: https://reactjs.org/docs/higher-order-components.html
function withLoader(WrappedComponent) {
  return class extends React.Component {
    render() {
      const { data } = this.props
      if (data.loading) {
        return <Loader />
      }

      return <WrappedComponent data={data} {...this.props} />
    }
  }
}

export default withLoader



// WEBPACK FOOTER //
// ./src/containers/Loader.js